import { createDataActionFactory, Feature, ThunkDispatch } from '../../../shared';
import getEmailToPDLsMap from '../../dataLayer/ows/getEmailToPDLsMap';

export const emailToPDLsMapLoadCompletedAction = createDataActionFactory<
    { emailToPDLsMap: { [emailAddress: string]: string[] } },
    Error
>('EmailToPDLsMapLoadCompletedAction', Feature.PrivateDistributionList);

export const loadEmailToPDLsMapping = (dispatch: ThunkDispatch) =>
    getEmailToPDLsMap().then(
        emailToPDLsMap => {
            dispatch(emailToPDLsMapLoadCompletedAction.success({ emailToPDLsMap: emailToPDLsMap }));
        },
        error => {
            dispatch(emailToPDLsMapLoadCompletedAction.error(error));
        }
    );
